module.exports = __webpack_public_path__ + "images/63112ad633d9474e96e9241a6c251922.svg";